import XEndpoints from "../../core/config/Endpoints";
import XApi from "../../utils/Api";

export class QuotationService {
  // Sale
  async addQuotation(data: any) {
    const token = localStorage.getItem("token");
    if (token) {
      const response = await XApi.post(XEndpoints.quotation, data, {
        "Content-Type": "application/json",
        Authorization: token,
      });
      return response ?? null;
    }
    return null;
  }

  async updateQuotation(id: number, data: any) {
    const token = localStorage.getItem("token");
    if (token) {
      const response = await XApi.patch(
        `${XEndpoints.quotation}/detail/${id}`,
        data,
        {
          "Content-Type": "application/json",
          Authorization: token,
        }
      );
      return response ?? null;
    }
    return null;
  }

  async getQuotation(id: number) {
    const token = localStorage.getItem("token");
    if (token) {
      const response = await XApi.get(`${XEndpoints.quotation}/detail/${id}`, {
        "Content-Type": "application/json",
        Authorization: token,
      });
      return response ?? null;
    }
    return null;
  }

  async exportQuotation(data: any) {
    const token = localStorage.getItem("token");
    if (token) {
      const response = await XApi.post(`${XEndpoints.quotation}/export`, data, {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      });
      return response ?? null;
    }
    return null;
  }

  // Delivery Challan
  async addDeliveryChallan(data: any) {
    const token = localStorage.getItem("token");
    if (token) {
      const response = await XApi.post(XEndpoints.deliveryChallan, data, {
        "Content-Type": "application/json",
        Authorization: token,
      });
      return response ?? null;
    }
    return null;
  }

  async updateDeliveryChallan(id: number, data: any) {
    const token = localStorage.getItem("token");
    if (token) {
      const response = await XApi.patch(
        `${XEndpoints.deliveryChallan}/detail/${id}`,
        data,
        {
          "Content-Type": "application/json",
          Authorization: token,
        }
      );
      return response ?? null;
    }
    return null;
  }

  async getDeliveryChallan(id: number) {
    const token = localStorage.getItem("token");
    if (token) {
      const response = await XApi.get(
        `${XEndpoints.deliveryChallan}/detail/${id}`,
        {
          "Content-Type": "application/json",
          Authorization: token,
        }
      );
      return response ?? null;
    }
    return null;
  }

  async exportDeliveryChallan(data: any) {
    const token = localStorage.getItem("token");
    if (token) {
      const response = await XApi.post(
        `${XEndpoints.deliveryChallan}/export`,
        data,
        {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      );
      return response ?? null;
    }
    return null;
  }
}
